import React, { useEffect, useState } from "react"
import { OtroTallerStyles, buttonStyleToT } from "../../utils/styles"
import { LoadingButton } from "@mui/lab"
import Multifile from "../../components/Multifile"

let vs = OtroTallerStyles()
const OtroTaller = ({ guardarOtroTaller, files, setFiles }) => {
  let OtroTallerStyles = vs()
  const [loading, setLoading] = useState(false)

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div className={OtroTallerStyles.top}>
          <div className={OtroTallerStyles.title}>{<p>FACTURAS</p>}</div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center"
          }}
        >
          <Multifile
            loading={loading}
            setLoading={setLoading}
            files={files}
            setFiles={setFiles}
            firebaseFolder={"FACTURAS_ORDEN_DE_SERVICIO"}
          />
        </div>

        <div
          className={OtroTallerStyles?.buttonAreaContainer}
          style={{ width: "80%", backgroundColor: "#ffffff" }}
        >
          <div
            className={OtroTallerStyles?.buttonContainer}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <LoadingButton
              sx={buttonStyleToT}
              className={OtroTallerStyles?.buttonSave}
              onClick={async (e) => {
                guardarOtroTaller(files)
              }}
            >
              GUARDAR
            </LoadingButton>
          </div>
        </div>
      </div>
    </div>
  )
}
export default OtroTaller
